// extracted by mini-css-extract-plugin
export default {"group":"RadioGroup_group__8HFPe","option":"RadioGroup_option__agSC+"};